export default __webpack_public_path__ + "static/media/video.3cb25c85.mp4";